import SimulationList from '@/components/simulation/SimulationList.tsx';

export default function AdminSimulationsPage() {
  return (
    <div className="animate-fade-in">
      <SimulationList />
    </div>
  );
}
